import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER,LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import {  TranslateService, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { translatePartialLoader, missingTranslationHandler } from './config/translation.config';
import { HttpClient } from '@angular/common/http';
import {  Title } from '@angular/platform-browser';

// Bootstrap DataTable
import { ToastrModule } from 'ngx-toastr';
import {HttpClientModule} from '@angular/common/http';
import {DataTablesModule} from 'angular-datatables';
import { httpInterceptorProviders } from './core/interceptor';
import { ApplicationConfigService } from './core/config/application-config.service';
import { environment } from 'src/environments/environment';
import { NgxWebstorageModule, SessionStorageService } from 'ngx-webstorage';
import { TranslateModule } from '@ngx-translate/core';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import {ConfirmationDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {ConfirmationDialogService} from './confirm-dialog/confirm-dialog.service';
import {NgSelect2Module} from 'ng-select2';
import {NgSelectModule} from '@ng-select/ng-select';
import { CookieService } from 'ngx-cookie-service';
import { SharingModule } from './sharing/sharing.module';
import {AppComponent} from './app.component';
import {SharedModule} from 'primeng/api';
import { BnNgIdleService } from 'bn-ng-idle'; // import bn-ng-idle service

import { registerLocaleData } from '@angular/common';

import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.SSO.url ,
        realm: environment.SSO.realm,
        clientId: environment.SSO.clientId 
      },
     
        initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
        },

       
       loadUserProfileAtStartUp: false,
        enableBearerInterceptor: true,
        bearerPrefix: 'Bearer',
        bearerExcludedUrls: [
            '/assets',
          ],
    /*initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html'
      }*/
    }
    
    );
}



@NgModule({
  declarations: [
    AppComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    NgSelect2Module,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgSelectModule,
    AppRoutingModule,
    DataTablesModule.forRoot(),
    KeycloakAngularModule,
    NgxWebstorageModule.forRoot({ prefix: 'dgtt', separator: '-', caseSensitive: true }),
SharedModule,
SharingModule,


    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translatePartialLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useFactory: missingTranslationHandler,
      },
    }),
    ToastrModule.forRoot(
      {
        positionClass: 'toast-top-right',
        closeButton: true,
        timeOut: 10000

      }
    ),
  ],
  providers: [
      ConfirmationDialogService,
      CookieService,
      BnNgIdleService,
      Title,
    { provide: LOCALE_ID, useValue: 'fr' },
    httpInterceptorProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    applicationConfigService: ApplicationConfigService,
    translateService: TranslateService,
    sessionStorageService: SessionStorageService,
    )
    {
     // applicationConfigService.setEndpointPrefix(environment.API_BASE_URL);

     //applicationConfigService.setEndpointPrefix(location.origin);
      const langKey = sessionStorageService.retrieve('locale') ?? 'fr';
      translateService.use(langKey);
    }
 }
